import { render, staticRenderFns } from "./RecordedUploadForm.vue?vue&type=template&id=5a547662&scoped=true&"
import script from "./RecordedUploadForm.vue?vue&type=script&lang=ts&"
export * from "./RecordedUploadForm.vue?vue&type=script&lang=ts&"
import style0 from "./RecordedUploadForm.vue?vue&type=style&index=0&id=5a547662&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a547662",
  null
  
)

export default component.exports